module.exports = __webpack_public_path__ + "img/join-04.9ceef5e3.jpg";